import { NgModule } from '@angular/core';
import { CommonPackageModule } from 'src/app/modules/common-package.module';
import { FileUploadPopupComponent } from './file-upload-popup/file-upload-popup.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { MsgPopupComponent } from './msg-popup/msg-popup.component';
import { LoaderComponent } from './loader/loader.component';
import { CustomCalendarComponent } from './custom-calendar/custom-calendar.component';
import { ContentPopupComponent } from './content-popup/content-popup.component';
import { SelectItemPopupComponent } from './select-item-popup/select-item-popup.component';
import { SelectTccPopupComponent } from './select-tcc-popup/select-tcc-popup.component';
import { CommonChartComponent } from './common-chart/common-chart.component';
import { BuildImportComponent } from './build-import/build-import.component';
import { CustomNotificationComponent } from './custom-notification/custom-notification.component';
import { GridMwoErrorComponent } from './grid-mwo-error/grid-mwo-error.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DetailsPopupComponent } from './details-popup/details-popup.component';
import { CustomGridFilterComponent } from './custom-grid-filter/custom-grid-filter.component';
@NgModule({
  declarations: [FileUploadComponent,
    FileUploadPopupComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    MsgPopupComponent,
    LoaderComponent,
    CustomCalendarComponent,
    ContentPopupComponent,
    SelectItemPopupComponent,
    SelectTccPopupComponent,
    CommonChartComponent,
    BuildImportComponent,
    CustomNotificationComponent,
    GridMwoErrorComponent,
    DateRangePickerComponent,
    DetailsPopupComponent,
    CustomGridFilterComponent
  ],
  imports: [
    CommonPackageModule,
    NgxDaterangepickerMd
  ],
  exports: [FileUploadComponent,
    FileUploadPopupComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    MsgPopupComponent,
    LoaderComponent,
    CustomCalendarComponent,
    ContentPopupComponent,
    SelectItemPopupComponent,
    SelectTccPopupComponent,
    CommonChartComponent,
    BuildImportComponent,
    CustomNotificationComponent,
    GridMwoErrorComponent,
    DateRangePickerComponent,
    DetailsPopupComponent,
    CustomGridFilterComponent
  ]
})
export class CommonFeatureModule {
}
